<template>
  <!--srcviewscompanydetailsBusinessActivitiesSupplyChainvuehtmlStart-->

  <div id="defaultId1 " style="padding-bottom: 20px" v-loading="RiskLoding">
    <div id="g2ede8" class="operations-content">
      <div class="operations-head-content">
        <h2 id="gf7b16" class="operations-head detail_title_20">
          Overview of Supply Chain Information
        </h2>

        <div id="g8b81a" @click="activeIcon = !activeIcon" class="Information">
          <svg
            id="idex5xpV"
            class="icon"
            t="1718690711396"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="4563"
            width="2.57rem"
            height="2.57rem"
          >
            <path
              id="id3aCJoQ"
              d="M928 938.666667H96a53.393333 53.393333 0 0 1-53.333333-53.333334V181.333333a53.393333 53.393333 0 0 1 53.333333-53.333333h832a53.393333 53.393333 0 0 1 53.333333 53.333333v704a53.393333 53.393333 0 0 1-53.333333 53.333334z m-245.333333-42.666667h245.333333a10.666667 10.666667 0 0 0 10.666667-10.666667v-202.666666h-256z m-298.666667 0h256v-213.333333H384z m-298.666667-213.333333v202.666666a10.666667 10.666667 0 0 0 10.666667 10.666667h245.333333v-213.333333z m597.333334-42.666667h256V426.666667h-256z m-298.666667 0h256V426.666667H384z m-298.666667 0h256V426.666667H85.333333z m853.333334-256V181.333333a10.666667 10.666667 0 0 0-10.666667-10.666666H96a10.666667 10.666667 0 0 0-10.666667 10.666666v202.666667z"
              :fill="activeIcon ? '#009EA7' : '#8497AB'"
              p-id="4564"
            ></path>
          </svg>
        </div>
      </div>
      <div class="Product_Supply_select flex_center_bettwen">
        <div class="">
          <el-select
            style="width: 27.857143rem"
            @change="ChangCountry"
            v-model="Importyear"
            placeholder="Please Select"
          >
            <el-option
              v-for="(item, index) in Yearoptions"
              :disabled="!item.hasData"
              :key="index"
              :label="item.year"
              :value="item.year"
            >
            </el-option>
          </el-select>
          <el-select
            filterable=""
            @change="getData()"
            style="width: 27.857143rem; margin-left: 20px"
            v-model="Country"
            placeholder="Please Select"
          >
            <el-option
              v-for="(item, index) in Countryoptions"
              :key="index"
              :label="item.countryName"
              :value="item.countryCode"
            >
            </el-option>
          </el-select>
        </div>
        <el-button
          style="background-color: #009ea7 !important"
          class="btn_export"
          @click="getProductSupplyChainFilterYear"
        >
          Reset</el-button
        >
      </div>
      <div class="operations-box">
        <div ref="SupplyChainEchart" style="width: 98%; height: 642px"></div>
      </div>
    </div>
    <div id="g2ede8" class="operations-content margin-top10" v-if="activeIcon">
      <h2 id="gf7b16" class="operations-head detail_title_20">
        Origin Information Overview
      </h2>

      <div class="table-biao margin-top20">
        <el-table
          :data="countryOfImporter"
          ref="table"
          empty-text="No Data"
          style="width: 100%"
          class="table_height_30 table_font_size_14 table_contentHeight_40"
        >
          <el-table-column align="left" label=" # " show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="countryOfImporter"
            label=" Origin "
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.row.countryOfImporter }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="transactions"
            label="transactions"
            width="280"
            align="left"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.transactions | FilterNum }}</span>
              <!-- </el-tooltip> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div id="g2ede8" class="operations-content margin-top10" v-if="activeIcon">
      <h2 id="gf7b16" class="operations-head detail_title_20">
        Destination Information Overview
      </h2>

      <div class="table-biao margin-top20">
        <el-table
          :data="countryOfSupplier"
          ref="table"
          empty-text="No Data"
          style="width: 100%"
          class="table_height_30 table_font_size_14 table_contentHeight_40"
        >
          <el-table-column align="left" show-overflow-tooltip label=" # ">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="countryOfSupplier"
            label=" Destination"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.row.countryOfSupplier }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="transactions"
            label="transactions"
            width="280"
            align="left"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.transactions | FilterNum }}</span>
              <!-- </el-tooltip> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>

<script>
import {
  getProductSupplyChain,
  getProductSupplyChainFilter,
  getProductSupplyChainTopTenCountries,
} from "@/api/companyApi.js";
import ReLogin from "../../../../components/ReLogin.vue";
export default {
  name: "",
  // props: {},
  components: {
    ReLogin,
  },
  data() {
    return {
      data: {
        links: [],
        nodes: [],
      },
      RiskLoding: false,
      ExporttableData: [],
      activeIcon: false,
      nodes: [], //{ name: 'Climate change' }
      links: [],
      reLoginVis: false,
      Country: "",
      Importyear: "",
      companyList: [],
      Yearoptions: [],

      Countryoptions: [],
      countryOfImporter: [],
      countryOfSupplier: [],
    };
  },
  mounted() {
    this.$store.dispatch("app/setTools", {
      name: "select",
      key: "isActive",
      value: false,
    });
    this.getProductSupplyChainFilterYear();
    this.$emit("UpdatamarkTotalList", false);

    window.addEventListener("resize", this.resizeFn);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeFn);
  },
  methods: {
    resizeFn() {
      this.suppleEchart();
    },
    default() {},
    ChangCountry() {
      let CountryData = [];
      CountryData = this.Yearoptions.filter(
        (item) => item.year == this.Importyear,
      );
      this.Countryoptions = CountryData[0].countries;
      this.Country = this.Countryoptions[0].countryCode;
      this.getData();
    },
    getProductSupplyChainFilterYear() {
      getProductSupplyChainFilter({
        hsCode: this.$route.query.id3a,
      }).then((res) => {
        if (res.code == 200) {
          this.Yearoptions = res.data;

          let arr = res.data.filter((item) => item.hasData == true);
          this.Importyear = arr[0].year;
          this.Country = arr[0].countries[0].countryCode;
          this.ChangCountry();
        } else {
          this.Yearoptions = [];
        }
      });
    },
    getData() {
      this.getProductSupplyChainTopTenCountriesList();

      this.RiskLoding = true;
      let existingChart = this.$echarts.getInstanceByDom(
        this.$refs.SupplyChainEchart,
      );
      if (existingChart) {
        existingChart.dispose(); // 销毁旧的实例
      }
      getProductSupplyChain({
        hsCode: this.$route.query.id3a,
        year: this.Importyear,
        countryCode: this.Country,
      })
        .then((result) => {
          // let data = JSON.parse(crypto.decrypt(result));
          let data = result;
          if (data.code == 200) {
            this.RiskLoding = false;
            const listNode = data.data.nodes;
            let arr = [];
            const listLinks = data.data.links;
            this.companyList = data.data.nodes;
            let arrLink = [];

            listNode.forEach((item) => {
              const pobj = {
                name: item.nameEn,
              };
              arr.push(pobj);
            });
            this.nodes = arr;

            listLinks.forEach((item, index) => {
              const obj = {
                source: item.sourceEn,
                target: item.targetEn,
                value: item.value,
              };
              arrLink.push(obj);
            });

            // this.linkpre = arrLink
            this.links = arrLink;

            // this.findLink()
            this.suppleEchart();
          } else {
            this.RiskLoding = false;
          }
        })
        .catch((err) => {
          this.RiskLoding = false;
          this.reLoginVis = String(err).includes("403");
        });
    },

    suppleEchart() {
      let that = this;

      if (this.echartsBox) {
        this.echartsBox.dispose();
      }
      this.echartsBox = this.$echarts.init(this.$refs.SupplyChainEchart);

      const option = {
        grid: {
          left: "0%", // 调整这个数值来控制图表在容器中的左侧位置
          // 其他 grid 相关设置
        },
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
        },
        series: [
          {
            type: "sankey",
            data: that.nodes,
            links: that.links,
            emphasis: {
              focus: "adjacency",
            },
            levels: [
              {
                depth: 0,
                itemStyle: {
                  color: "#fbb4ae",
                },
                lineStyle: {
                  color: "source",
                  opacity: 0.6,
                },
              },
              {
                depth: 1,
                itemStyle: {
                  color: "#b3cde3",
                },
                lineStyle: {
                  color: "source",
                  opacity: 0.6,
                },
              },
              {
                depth: 2,
                itemStyle: {
                  color: "#ccebc5",
                },
                lineStyle: {
                  color: "source",
                  opacity: 0.6,
                },
              },
              {
                depth: 3,
                itemStyle: {
                  color: "#decbe4",
                },
                lineStyle: {
                  color: "source",
                  opacity: 0.6,
                },
              },
            ],
            lineStyle: {
              curveness: 0.5,
            },
          },
        ],
      };
      this.echartsBox.setOption(option);
    },
    getProductSupplyChainTopTenCountriesList() {
      getProductSupplyChainTopTenCountries({
        hsCode: this.$route.query.id3a,
        year: this.Importyear,
        countryCode: this.Country,
      }).then((res) => {
        if (res.code == 200) {
          console.log(11111);

          this.countryOfSupplier = res.data.countryOfSupplier;
          this.countryOfImporter = res.data.countryOfImporter;
        } else {
          this.countryOfSupplier = [];
          this.countryOfImporter = [];
        }
      });
    },
  },
  computed: {},
};
</script>
<style scoped>
.operations-content {
  padding: 30px 40px;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
}

/deep/ .el-table td.el-table__cell {
  border-right: none;
  height: 3.71rem;
}

.Product_Supply_select {
  padding: 20px;
  background: #f5f5f5;
  border-radius: 4px;
}

.Information {
  width: 64px;
  height: 40px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  border-radius: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media screen and (max-width: 1920px) {
  .operations-content {
    padding: 22px 30px;
  }
}
@media screen and (max-width: 1439px) {
  .operations-content {
    padding: 20px 30px;
  }
}
</style>
